import {useEffect, useState} from 'react'
import {sanityClient} from './client'
import {articleBySlugQuery} from './queries'

export function useArticle(slug) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    sanityClient
      .fetch(articleBySlugQuery, {slug})
      .then((res) => {
        if (!cancelled) {
          setData(res || null)
          setLoading(false)
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err)
          setLoading(false)
        }
      })
    return () => {
      cancelled = true
    }
  }, [slug])

  return {data, loading, error}
}

